if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"suite_shell","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return "default-webpack_sharing_consume_default_snelstart_feature-navigation-bar_snelstart_feature-na-595d72" != chunkId},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}